import { Lang } from './lang';
import { Pager } from './pager';

export interface Signatureartist {
  code: string;
  id: number;
  img: {
    src: string;
    height: number;
    width: number;
  };
  smart_url: string;
  title: string;
  url: string;
}
export interface SignatureartistFilter {
  CODE: string;
  IBLOCK_ID: number;
}

export interface SignatureartistQueryResponse {
  data: Signatureartist[];
  lang: Lang;
  // TODO no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userId: any;
  // TODO no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filter: any;
  pager: Pager;
}
